import { useQuery } from "react-query";
import { getSecurities } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useSecurity = () => {
  const { data, isLoading, refetch } = useQuery("GetSecurity", getSecurities, {
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, refetch };
};
